import { combineReducers } from "@reduxjs/toolkit";
import authorizeSlice from "./authorizeSlice";
import authenticateSlice from "./authenticateSlice";

export const googleOAuthReducer = combineReducers({
  authorize: authorizeSlice,
  authenticate: authenticateSlice
})